export const TABLE_SKELETON_ROWS = 14

export const TABLE_SKELETON_CELL_WIDTH = [580, 472, 425, 523]

export const QA_NAME_TABLE_SKELETON = 'table_skeleton'
